module.exports = "/static/media/Devices.981ce8ef.svg";